import { Injectable } from '@angular/core';
import {
  AbstractControl,
  AsyncValidator,
  ValidationErrors,
} from '@angular/forms';
import { OptionService } from '@pulpo/pulpo-api';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class uniqueOptionRefValidator implements AsyncValidator {
  constructor(private optionService: OptionService) {}

  validate(control: AbstractControl): Observable<ValidationErrors | null> {
    return this.optionService.getByReference(control.value).pipe(
      map((response) => {
        return response?.body ? { existing: true } : null;
      }),
      catchError(() => {
        return of(null);
      })
    );
  }
}
